'use client';
import { useEffect } from 'react';

declare global { interface Window { chatwootSDK: any; chatwootSettings: any; } }

export function ChatwootScript() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://aesirchat.com/packs/js/sdk.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({
          websiteToken: 'NVXJPH8WrAqbWDw3FaLVKpGY',
          baseUrl: 'https://aesirchat.com',
        });
      }
    };
    document.body.appendChild(script);
    window.chatwootSettings = { position: 'right', type: 'expanded_bubble', launcherTitle: 'Fale conosco no chat' };
    return () => {
      document.body.removeChild(script);
      delete window.chatwootSDK;
      delete window.chatwootSettings;
    };
  }, []);
  return null;
}